module.exports = __webpack_public_path__ + "img/img19.8ee21aa5.svg";